// ReduxSlices/Inventory/inventorySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Fetch initial inventory list
export const fetchInventories = createAsyncThunk(
  'inventory/fetchInventories',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch('/api/v1/inventories');
      if (!res.ok) throw new Error('Network response was not ok');
      const data = await res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const DeleteInventories = createAsyncThunk(
  'inventory/deleteInventories',
  async (id, { rejectWithValue }) => {
    try {
      const res = await fetch(`/api/v1/inventories/${id}`, {
        method: 'DELETE',
        credentials: "include",
      });
      if (!res.ok) throw new Error('Failed to delete medication');
    
      return id;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// Create or update inventory item
export const saveInventory = createAsyncThunk(
  'inventory/saveInventory',
  async ({ inventory, id }, { rejectWithValue }) => {
    try {
      const url = id ? `/api/v1/inventories/${id}` : '/api/v1/inventories';
      const method = id ? 'PUT' : 'POST';
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ inventory }),
      });

      const data = await res.json();
      if (data.errors) throw new Error(data.errors.join(', '));

      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const inventorySlice = createSlice({
  name: 'inventory',
  initialState: {
    inventories: [],
    loading: false,
    error: null,
    submitting: false,
  },
  reducers: {
    subscribeInventories(state, action) {
      const { action: wsAction, inventory } = action.payload;

      const index = state.inventories.findIndex(inv => inv.id === inventory.id);

      if (wsAction === 'created' && index === -1) {
        // Add new item at the start
        state.inventories.unshift(inventory);
      } else if (wsAction === 'updated' && index >= 0) {
        // Replace existing item completely
        state.inventories[index] = {
          ...state.inventories[index],
          ...inventory
        };
      } else if (wsAction === 'deleted' && index >= 0) {
        // Remove item
        state.inventories.splice(index, 1);
      }
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventories.fulfilled, (state, action) => {
        state.loading = false;
        const map = new Map();
        action.payload.forEach(item => {
          map.set(item.id, item);
        });

        state.inventories.forEach(item => {
          if (!map.has(item.id)) map.set(item.id, item);
        });

        state.inventories = Array.from(map.values());
      })
      .addCase(fetchInventories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveInventory.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(saveInventory.fulfilled, (state, action) => {
        state.submitting = false;
        const index = state.inventories.findIndex((inv) => inv.id === action.payload.id);
        if (index >= 0) {
          state.inventories[index] = action.payload;
        } else {
          state.inventories.unshift(action.payload);
        }
      })
      .addCase(saveInventory.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      })
      .addCase(DeleteInventories.fulfilled, (state, action) => {
        state.inventories = state.inventories.filter(
          (inv) => inv.id !== action.payload
        );
      });
  },
});

export const { subscribeInventories: subscribeInventoriesAction } = inventorySlice.actions;
export default inventorySlice.reducer;
